// themes/theme.js
import { createTheme } from '@mui/material/styles';

const getTheme = (mode = 'light') =>
  createTheme({
    palette: {
      mode, // 'light' | 'dark'
    },
  });

export default getTheme;